export const blockIconsCommunicationQrCode2 = (
	<span className='material-symbols-outlined'>qr_code_2</span>
);
